import { dashMetaJson } from '../../../shared/api/dash-meta-fetch';

export interface GetTextAssistBody {
  prompt?: string;
  template: string;
  contentSize?: 'small' | 'medium' | 'large' | 'fullPage';
  metrics?: Array<{
    value: string;
    description: string;
  }>;
  filters?: Array<{
    id: string;
    label: string;
  }>;
}

export interface GetTextAssistResponse {
  template: string;
}

export const getTextAssist = (body: GetTextAssistBody, init?: RequestInit) =>
  dashMetaJson<GetTextAssistResponse>('/api/build-a-dash/ai-gen/text-assist', {
    method: 'POST',
    body: JSON.stringify(body),
    signal: init?.signal,
  });

export interface GetTextSummaryBody {
  text: string;
  prompt?: string;
  minLength?: number;
  maxLength?: number;
}

export interface GetTextSummaryResponse {
  summary: string;
}

export const getTextSummary = (body: GetTextSummaryBody) =>
  dashMetaJson<GetTextSummaryResponse>(
    '/api/build-a-dash/ai-gen/text-summary',
    {
      method: 'POST',
      body: JSON.stringify(body),
    }
  );
